import React from "react"
import { Link } from "gatsby"
import Image from "../components/Image"

function Card({ image, heading, date, location, url, ...rest }) {
  return (
    <Link
      to={url}
      className="duration-200 transform group hover:-translate-y-2"
      {...rest}
    >
      <Image image={image.image} alt={image.alt} className="overflow-hidden rounded-md" />
      <h3 className="mt-3 text-lg font-bold group-hover:underline text-primary-dark">
        {heading}
      </h3>
    </Link>
  )
}

export default Card
